export default __webpack_public_path__ + "maps-examples-line-gradient-960-2b58899b599cc85c20eeefe26dd46a06.png";